export class SettingsEarningsEntity {
  constructor() {
    this.earningsId = null;
    this.earningsName = null;
    this.earningsLastKnownDate = null;
    this.earningsFrequency = null;
    this.earningsLastKnownAmount = null;
    this.earningsEnabledFlag = null;
  }
  getSettingsEarningsEntity() {
    return this;
  }
  getEarningsId() {
    return this.earningsId;
  }
}

export default SettingsEarningsEntity;
